import React from "react"
import ReactKonva from "react-konva"
import { ImageCropper } from "../lib/imageCropper"
class PolygonCropEditor extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            handleOnPolygonCornerNo: 0,
            debug: null
        }
    }

    onHandleMouseOver = ({ target }) => {
        document.body.style.cursor = "pointer"
        target.setStrokeWidth(target.getStrokeWidth() * 1.4)
        this.refs.cropPolygonLayer.draw()
    }

    onHandleMouseOut = ({ target }) => {
        document.body.style.cursor = "default"
        target.setStrokeWidth(target.getStrokeWidth() / 1.4)
        this.refs.cropPolygonLayer.draw()
    }

    onHandleMouseDown = ({ target }) => {
        this.refs.cropPolygonGroup.setDraggable(false)
        target.moveToTop()
    }

    onHandleDragEnd = ({ target }) => {
        this.refs.cropPolygonGroup.setDraggable(true)
        this.refs.cropPolygonLayer.draw()
    }
    onPolygonDragMove = ({ target }) => {
        const { handleX, handleY } = this.getHandlePosition(target.x(), target.y(), target.rotation(), target.radius())
        var handle = this.refs.cropPolygonHandle
        handle.setX(handleX)
        handle.setY(handleY)
    }

    onHandleDragMove = ({ target }) => {

        Math.dist = (x1,y1,x2,y2) => { 
            if(!x2) x2=0; 
            if(!y2) y2=0;
            return Math.sqrt((x2-x1)*(x2-x1)+(y2-y1)*(y2-y1)); 
        }

        Math.toDegrees = (angle) => {
            return angle * (180 / Math.PI);
        }

        Math.angle = (x1,y1,x2,y2) => {
            const deltaY = (y1 - y2);
            const deltaX = (x2 - x1);
            const result = Math.toDegrees(Math.atan2(deltaY, deltaX)); 
            return (result < 0) ? (360 + result) : result;
        }

        const newHandleX = target.getX()
        const newHandleY = target.getY()
        const newRadius = Math.dist(this.refs.cropPolygon.getX(), this.refs.cropPolygon.getY(), newHandleX, newHandleY)
        const handleAngle = 90 - Math.angle(this.refs.cropPolygon.getX(), this.refs.cropPolygon.getY(), newHandleX, newHandleY)
        const handlePositionInitialAngle = Math.toDegrees(this.state.handleOnPolygonCornerNo * 2 * Math.PI / this.props.polygonNumberOfSides)
        const newRotation = handleAngle - handlePositionInitialAngle
        const cropPolygon = this.refs.cropPolygon;
        cropPolygon.setRadius(newRadius)
        cropPolygon.setRotation(newRotation)
        this.refs.cropPolygonLayer.draw()
    }

    // Calculate the round handle attributes from the polygon's attributes
    getHandlePosition = (x, y, rotation, radius) => {

        if(!this.props.selectedSourceImage)
            return {x: null, y: null}

        Math.toRadians = (angle) => {
            return angle * (Math.PI / 180);
        }

        const polygonRotation = Math.toRadians(rotation)
        const handleX = radius *      Math.sin(polygonRotation + this.state.handleOnPolygonCornerNo * 2 * Math.PI / this.props.polygonNumberOfSides) + x
        const handleY = -1 * radius * Math.cos(polygonRotation + this.state.handleOnPolygonCornerNo * 2 * Math.PI / this.props.polygonNumberOfSides) + y
        return { handleX, handleY }
    }
    
    getCurrentCropParameters = () => {
        const p = this.refs.cropPolygon
        return { cropPolygonX: p.x(), cropPolygonY: p.y(), cropPolygonRadius: p.radius(), cropPolygonRotation: p.rotation() }
    }

    componentDidUpdate = () => {
        if(this.props.generateCrop) {
            var cropImage = this.cropImage.current.getImage()
            const lastCroppedSourceFileImageMd5 = this.props.selectedSourceImage.imageMd5
            const p = this.refs.cropPolygon
            ImageCropper.createCroppedImageUrl(cropImage, this.props.polygonNumberOfSides, this.props.cropPolygonX, this.props.cropPolygonY, this.props.cropPolygonRadius, this.props.cropPolygonRotation,
                (ctx) => {
                    p.current.sceneFunc.apply(p.current, [ctx])
                }, 
                (croppedImageDataUrl) => {
                    this.props.onCroppedDataUrl(croppedImageDataUrl, this.props.cropPolygonX, this.props.cropPolygonY, this.props.cropPolygonRadius, this.props.cropPolygonRotation, lastCroppedSourceFileImageMd5)
                })
        }
    }

    cropImage = React.createRef()

    render() {

        const scale = this.props.selectedSourceImage ? this.props.panelWidth / this.props.selectedSourceImage.width : null
        const height = this.props.selectedSourceImage ? this.props.selectedSourceImage.height * scale : null
        const image = this.props.selectedSourceImage ? this.props.selectedSourceImage.image : null

        const imageHasChanged = !this.props.selectedSourceImage || this.props.selectedSourceImage.imageMd5 !== this.props.lastCroppedSourceFileImageMd5

        const smallesWidthHeight = image ? Math.min(image.width, image.height) : 0
        const strokeWidth = smallesWidthHeight * .9 * 0.007
        const handleRadius = smallesWidthHeight * .9 * 0.06

        let cropPolygonX
        let cropPolygonY
        let rotation
        let cropPolygonRadius
        if(image && !imageHasChanged) {
            cropPolygonX = this.props.cropPolygonX
            cropPolygonY = this.props.cropPolygonY
            rotation = this.props.cropPolygonRotation
            cropPolygonRadius = this.props.cropPolygonRadius
        } else {
            cropPolygonX = image ? image.width / 2 : 0
            cropPolygonY = image ? image.height / 2 : 0
            rotation = 0
            cropPolygonRadius = smallesWidthHeight * .9 / 2
        }

        const { handleX, handleY } = this.getHandlePosition(cropPolygonX, cropPolygonY, rotation, cropPolygonRadius)

        return (
            <ReactKonva.Stage 
                width={this.props.panelWidth}
                height={height}
                scale={{x: scale, y: scale}} >
                <ReactKonva.Layer ref="cropPolygonLayer">
                    <ReactKonva.Group ref="cropPolygonGroup">
                        <ReactKonva.Image ref={this.cropImage}
                            image={image}
                            draggable={false} />
                        <ReactKonva.RegularPolygon ref="cropPolygon"
                            x={cropPolygonX}
                            y={cropPolygonY}
                            rotation={rotation}
                            radius={cropPolygonRadius}
                            sides={this.props.polygonNumberOfSides}
                            useCache={true}
                            stroke={"#ece835"}
                            strokeWidth={strokeWidth}
                            draggable={true}
                            listening={true} 
                            onDragMove={this.onPolygonDragMove} />
                    </ReactKonva.Group>
                    <ReactKonva.Circle ref="cropPolygonHandle"
                        x={handleX}
                        y={handleY}
                        stroke={"#ece835"}
                        strokeWidth={strokeWidth}
                        radius={handleRadius}
                        draggable={true} 
                        onDragMove={this.onHandleDragMove}
                        onMouseDown={this.onHandleMouseDown}
                        onTouchStart={this.onHandleMouseDown}
                        onDragEnd={this.onHandleDragEnd}
                        onMouseOver={this.onHandleMouseOver}
                        onMouseOut={this.onHandleMouseOut} />
                </ReactKonva.Layer>
            </ReactKonva.Stage>
        )
    }
}

export default PolygonCropEditor


// WEBPACK FOOTER //
// ./src/components/PolygonCropEditor.jsx